// src/mixins/twilioMixin.js
import VoiceAPI from "dashboard/api/voice.js";
import TWILIO_SERVICE, {TWILIO_EVENTS,CALL_LOCAL_STATUS} from "dashboard/helper/twilio_sdk.js"
import { mapGetters } from 'vuex';
import ContactsAPI from "dashboard/api/contacts.js"
import moment from "moment";

export default {
  data() {
    return {
    //   twilioInitialized: false,
      // callDuration: 0, // seconds
      callStartTime: null,
      callTimer: null,
    };
  },
  computed:{
    ...mapGetters({
      currentUser: 'getCurrentUser',
      getAccount: 'accounts/getAccount',
      twilioCall: 'contactConversations/getTwilioCall',
    }),
    currentAccount(){
      return this.getAccount(this.currentUser.account_id);
    },
    hasTwilioCall(){
      return this.currentAccount?.has_twilio_call;
    },
  },
  // async mounted() {
  //   await this.initializeTwilio();

  //   // Listen for incoming calls globally
  //   window.bus.$on(TWILIO_EVENTS.INCOMMING_CALL, async (call) => {
  //     console.log('Incoming call inside mixin',call);

  //     try {
  //       const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
  //       stream.getTracks().forEach(track => track.stop());

  //       // emit event to open receive popup if user click receive btn, then accept the call
  //       // call.accept();

  //     } catch (err) {
  //       console.error("Mic permission denied for incoming call ❌", err);
  //       call.reject();
  //     }
  //   });
  // },
  methods: {
    async initializeTwilio(params) {
    //   if (this.twilioInitialized) return;

      try {
        const { data } = await VoiceAPI.generate_tokens(params);
        const device = await TWILIO_SERVICE.init(data.token);
        // this.twilioInitialized = true;
        console.log("Twilio initialized ✅",device);
      } catch (err) {
        console.error("Twilio init failed ❌", err);
      }
    },

    async requestMicPermission() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        stream.getTracks().forEach(track => track.stop());
        return true;
      } catch (err) {
        console.error("Microphone access denied ❌", err);
        return false;
      }
    },
    // async makeCall(args) {
    async makeTwioloCall(args) {
      const hasMic = await this.requestMicPermission();
      if (!hasMic) {
        alert("You need to allow microphone access to place a call.");
        return;
      }

      const call = await TWILIO_SERVICE.connect(args);
      console.log("Calling...", call);
      if (call) {
        // this.$store.dispatch('contactConversations/setIncomingCall', {...args,direction:"outgoing"});
        this.$store.dispatch('contactConversations/setIncomingCall', {
          call,
          params:{...args,direction:"outgoing"},
          contact:{
            phone_number: args.To,
            name: args.name,
          }
        });
        this.$store.dispatch('contactConversations/setCallStatus', CALL_LOCAL_STATUS['started']);
        // listed to disconnect the call
        call.on('disconnect', () => {
          console.log("Disconnected call:update state");
          this.$store.dispatch('contactConversations/endCall');
          this.$store.dispatch('contactConversations/setCallStatus', CALL_LOCAL_STATUS['ended']);
          this._stopCallTimer();
        });

        call.on("accept", () => {
          console.log("update state: Outgoing call accepted!");
          this.$store.dispatch('contactConversations/setCallStatus', CALL_LOCAL_STATUS['in_process']);
          this._startCallTimer();
        });

      }

      return call;
    },
    endCall(){
      this.twilioCall?.callInstance?.disconnect();
      this.$store.dispatch('contactConversations/setCallStatus', CALL_LOCAL_STATUS['ended']);
    },
    onIncommingCallCancel(){
      // dispatch to cancel the call instance,
      // this.endCall();
      this.twilioCall?.callInstance?.reject()
      // update the status
      this.$store.dispatch('contactConversations/clearTwilioCall');
    },
    async onIncommingCallAccept(){
      console.log("Accepting");
      // chek mic permission
      const hasMic = await this.requestMicPermission();
      if (!hasMic) {
        alert("You need to allow microphone access to answer the call.");
        this.twilioCall?.callInstance?.reject()
        return;
      }
      this.twilioCall?.callInstance?.accept();

      // dispatch the call the redux

      this.navigateToContactPage(this.twilioCall?.callInstance?.parameters?.From);

      return {
        isAccepted: true,
      };
    },
    async navigateToContactPage(phone_number){
      try {
        const {data} = await ContactsAPI.search(phone_number);
        console.log("Contacts ",data);
        if (data.payload) {
          const callerContact = data.payload.find(el=>el.phone_number === phone_number);
          if (callerContact) {
            // keep the name in store
            //
            this.$store.dispatch('contactConversations/updateCallContact', {
                phone_number,
                name: callerContact.name || "",
            });

            this.$router.push(`/app/accounts/${this.currentUser.account_id}/contacts/${callerContact.id}`);
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    _startCallTimer() {
      if (this.callTimer) return; // ✅ Don't start again

      this.callStartTime = Date.now();
      // this.callDuration = 0;

      if (this.callTimer) clearInterval(this.callTimer);

      this.callTimer = setInterval(() => {
        const seconds = Math.floor((Date.now() - this.callStartTime) / 1000);

        // this.callDuration = seconds
        this.$store.dispatch('contactConversations/updaeCallDuration', seconds);
      }, 1000);
    },

    _stopCallTimer() {
      if (this.callTimer) {
        clearInterval(this.callTimer);
      }
      this.callTimer = null;
      this.callStartTime = null;
      // this.callDuration = 0;
      this.$store.dispatch('contactConversations/updaeCallDuration', 0);

    },


    hangUp() {
      TWILIO_SERVICE.disconnectAll();
    },

       _registerTwilioBusListeners() {
      // avoid multiple listeners
      // window.bus.$off();

      // === Incoming ===
      window.bus.$on(TWILIO_EVENTS.INCOMING_CALL, (call) => {
        console.log("Incoming call event", call);
        // push to store with correct params

        const args = {
          phone_number:  call.parameters?.From,
          // contact_id:  call.customParameters?.get("contact_id"),
          // account_id:  call.customParameters?.get("account_id"),
        }
        console.log("Incomming call = ",args);
        this.$store.dispatch('contactConversations/setIncomingCall', {
          call,
          params:{...args,direction:"incomming"},
          contact:{
            phone_number: call.parameters?.From,
            name: "",
          }
        });
        this.$store.dispatch('contactConversations/setCallStatus', CALL_LOCAL_STATUS['started']);
      });

      // === Outgoing & common ===

      // window.bus.$on(TWILIO_EVENTS.CALL_RINGING, () => {
      //   this.$store.dispatch("contactConversations/setCallStatus", "ringing");
      // });

      window.bus.$on(TWILIO_EVENTS.CALL_ACCEPTED, (call) => {
        // this.$store.dispatch("contactConversations/setOutgoingCall", call);
        this.$store.dispatch("contactConversations/setCallStatus", CALL_LOCAL_STATUS['in_process']);
        this._startCallTimer();
      });

      window.bus.$on(TWILIO_EVENTS.CALL_REJECTED, () => {
        // this.$store.dispatch("contactConversations/endCall");
        this.$store.dispatch("contactConversations/setCallStatus", CALL_LOCAL_STATUS["ended"]);
        this._stopCallTimer();
      });

      window.bus.$on(TWILIO_EVENTS.CALL_CANCELLED, () => {
        console.log("Got missed call");
        // missed call: clear the state
        this.$store.dispatch('contactConversations/clearTwilioCall');
        // this.$store.dispatch("contactConversations/setCallStatus", CALL_LOCAL_STATUS["ended"]);
        this._stopCallTimer();
      });

      window.bus.$on(TWILIO_EVENTS.CALL_DISCONNECTED, () => {
        // this.$store.dispatch("contactConversations/endCall");
        this.$store.dispatch("contactConversations/setCallStatus", CALL_LOCAL_STATUS["ended"]);
        this._stopCallTimer();
      });

      window.bus.$on(TWILIO_EVENTS.CALL_ERROR, (err) => {
        console.error("Call error from bus:", err);
        this.$store.dispatch("contactConversations/setCallStatus", CALL_LOCAL_STATUS["error"]);
        this._stopCallTimer();
      });

      // === Optional (advanced) ===
      window.bus.$on(TWILIO_EVENTS.CALL_MUTED, () => {
        this.$store.dispatch("contactConversations/setCallStatus", "muted");
      });

      window.bus.$on(TWILIO_EVENTS.CALL_UNMUTED, () => {
        this.$store.dispatch("contactConversations/setCallStatus", "unmuted");
      });

      window.bus.$on(TWILIO_EVENTS.CALL_RECONNECTING, () => {
        this.$store.dispatch("contactConversations/setCallStatus", "reconnecting");
      });

      window.bus.$on(TWILIO_EVENTS.CALL_RECONNECTED, () => {
        this.$store.dispatch("contactConversations/setCallStatus", "connected");
      });


      // outgoing call
      window.bus.$on(TWILIO_EVENTS.OUTGOING_CALL_ACCEPTED, () => {
        this.$store.dispatch("contactConversations/setCallStatus", CALL_LOCAL_STATUS.in_process);
        this._startCallTimer();
      });
      window.bus.$on(TWILIO_EVENTS.OUTGOING_CALL_DISCONNECTED, () => {
        this.$store.dispatch("contactConversations/setCallStatus", CALL_LOCAL_STATUS["ended"]);
        this._stopCallTimer();
      });
      window.bus.$on(TWILIO_EVENTS.OUTGOING_CALL_ERROR, () => {
        this.$store.dispatch("contactConversations/setCallStatus", CALL_LOCAL_STATUS["error"]);
        this._stopCallTimer();
      });

    },



    // end methods

  }
};
